var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvertiserIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m494.779 166.942c-.031 8.301-6.749 15.101-15.199 15.067-8.354-.034-15.099-6.835-15.067-15.199.157-36.313-13.822-70.505-39.372-96.29-.101-.093-.194-.197-.295-.29-25.514-25.607-59.461-39.797-95.641-39.96-8.356-.043-15.103-6.855-15.059-15.211.042-8.355 6.844-15.1 15.21-15.059 44.196.203 85.672 17.536 116.865 48.791.141.136.283.283.424.419 31.236 31.523 48.329 73.342 48.134 117.732z",
    fill: "#dfe7f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.247 166.679c-.045 8.397-6.889 15.092-15.211 15.059-8.356-.043-15.103-6.855-15.06-15.211.097-20.131-7.659-39.09-21.837-53.398-.012-.008-.026-.026-.038-.034-14.173-14.288-33.051-22.203-53.161-22.294-8.364-.032-15.109-6.833-15.077-15.197.043-8.356 6.845-15.101 15.209-15.069 28.143.117 54.549 11.166 74.405 31.121.061.049.115.111.167.162 19.866 20.058 30.736 46.643 30.603 74.861z",
    fill: "#dfe7f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.644 91.819c19.866 20.056 30.735 46.641 30.603 74.86-.045 8.397-6.889 15.092-15.211 15.059-8.356-.043-15.103-6.855-15.06-15.211.097-20.131-7.659-39.09-21.837-53.398-.012-.008-.026-.026-.038-.034l21.376-21.439c.062.051.116.112.167.163z",
    fill: "#c7cfe1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m494.779 166.942c-.031 8.301-6.749 15.101-15.199 15.067-8.354-.034-15.099-6.835-15.067-15.199.157-36.313-13.822-70.505-39.372-96.29-.101-.093-.194-.197-.295-.29l21.375-21.439c.141.136.283.283.424.419 31.236 31.523 48.329 73.342 48.134 117.732z",
    fill: "#c7cfe1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m147.922 438.99c-.402.417-37.054 37.128-37.34 37.41-4.15 4.14-10.82 4.07-14.89-.01l-37.65-37.72-.38-.38-37.37-37.44c-4.09-4.09-4.1-10.73-.01-14.84l30.9-31.04 6.26-6.28c4.1-4.12 10.77-4.14 14.89-.02l37.43 37.36.01.01.37.37 37.77 37.72c4.1 4.1 4.11 10.76.01 14.86z",
    fill: "#334973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.922 438.99c-.402.417-37.054 37.128-37.34 37.41-4.15 4.14-10.82 4.07-14.89-.01l-37.65-37.72-.38-.38 38.4-38.51 13.7-13.75.01.01.37.37 37.77 37.72c4.1 4.1 4.11 10.76.01 14.86z",
    fill: "#1f3259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.465 480.885-27.509 27.551c-4.74 4.747-12.431 4.753-17.179.013l-79.131-79.011c-4.747-4.74-4.753-12.431-.013-17.179l27.509-27.551c4.74-4.747 12.431-4.753 17.179-.013l79.131 79.011c4.748 4.741 4.754 12.432.013 17.179z",
    fill: "#1f3259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.302 361.61-21.65 21.69-44.4 44.47-23.25 23.29c-6.78 6.78-17.78 6.79-24.57.01 0 0-51.365-51.285-51.37-51.29l-44.88-44.81-6.56-6.55c-6.79-6.78-6.8-17.79-.02-24.57l89.31-89.45 63.66 63.58z",
    fill: "#ff4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.302 361.61-21.65 21.69-44.4 44.47-23.25 23.29c-6.78 6.78-17.78 6.79-24.57.01 0 0-51.365-51.285-51.37-51.29l13.71-13.74 87.8-88.06z",
    fill: "#cd0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m429.931 319.031-168.629 42.579-63.729-63.633-63.665-63.573 42.323-168.688c2.965-13.956 20.225-19.069 30.327-8.992l116.035 115.868.119.122 116.161 115.978c10.103 10.087 5.014 27.346-8.942 30.339z",
    fill: "#dfe7f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m429.931 319.031-168.629 42.579-63.729-63.633 125.019-125.385.119.122 116.161 115.978c10.104 10.087 5.015 27.346-8.941 30.339z",
    fill: "#c7cfe1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertiserIcons);
export default __webpack_public_path__ + "static/media/Advertiser-icons.11140aac12a9c43ee5aecb38a298461d.svg";
export { ForwardRef as ReactComponent };